const SET_SENDING = `SET_SENDING@${__filename}`;
const SET_SHARED_ENTRY = `SET_SHARED_ENTRY@${__filename}`;

const initialState = {
  isSending: false,
};

export function setSending(isSending) {
  return {
    type: SET_SENDING,
    isSending,
  };
}

export function setSharedEntry({ sharedEntryId, sharedEntryUrl }) {
  return {
    type: SET_SHARED_ENTRY,
    sharedEntryId,
    sharedEntryUrl,
  };
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SENDING:
      return { ...state, isSending: action.isSending };
    case SET_SHARED_ENTRY:
      return { ...state, sharedEntryId: action.sharedEntryId, sharedEntryUrl: action.sharedEntryUrl };
    default:
      return state;
  }
}
